"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _textmedia_1 = require("./_textmedia");
// "Text & image" — the single content section (SP5). Handles text-only, image+text
// (left/right/top), or text-over-image. `image-with-text` is the same thing, kept
// hidden for back-compat.
(0, manifest_1.registerSection)({
    type: 'rich-text', label: 'Text & image', icon: 'type', category: 'content',
    settingsSchema: zod_1.z.object({ ..._textmedia_1.textMediaShape }),
    defaults: () => ({ ...(0, _textmedia_1.textMediaDefaults)(), imageLayout: 'none' }),
    fields: _textmedia_1.textMediaFields,
});
//# sourceMappingURL=rich-text.js.map